import React from 'react';
import { Tag } from 'antd';
import { ExportOutlined, ImportOutlined, NodeIndexOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { transportKindLabelKey, type TransportKind } from '../transportDirection';

const KIND_STYLE: Record<TransportKind, { color: string; icon: React.ReactNode }> = {
  FACTORY_TO_CUSTOMER: { color: 'purple', icon: <NodeIndexOutlined /> },
  FACTORY_TO_WAREHOUSE: { color: 'geekblue', icon: <ImportOutlined /> },
  WAREHOUSE_TO_CUSTOMER: { color: 'green', icon: <ExportOutlined /> },
};

/** Decision 2026-10-04: „Fabryka → klient” / „Fabryka → magazyn” / „Magazyn → klient”. */
const TransportKindTag: React.FC<{ kind?: TransportKind | null }> = ({ kind }) => {
  const { t } = useTranslation(['transport']);
  if (!kind) return null;
  const style = KIND_STYLE[kind];
  return (
    <Tag data-testid="transport-kind-tag" color={style.color} icon={style.icon} style={{ marginInlineEnd: 0 }}>
      {t(transportKindLabelKey(kind))}
    </Tag>
  );
};

export default TransportKindTag;
